import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import API_URL from '../api/baseURL';

const WorkshopProfile = () => {
  const { id } = useParams(); // <-- Workshop user ID from URL
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${API_URL}/users/${id}`);
        setProfile(res.data);
      } catch (err) {
        setProfile(null);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [id]);

  if (loading) return <p className="p-6">Loading profile...</p>;
  if (!profile) return <p className="p-6">Workshop not found.</p>;

  return (
    <div className="max-w-3xl mx-auto mt-10 p-6 bg-white dark:bg-gray-900 shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-200">
        {profile.details?.businessName || profile.name || "Workshop"}
      </h2>
      <div className="space-y-2 text-sm">
        <p><strong>Contact:</strong> {profile.email}</p>
        <p><strong>Phone:</strong> {profile.details?.phone || '—'}</p>
        <p><strong>Address:</strong> {profile.details?.address || '—'}</p>
        <p><strong>Company Type:</strong> {profile.details?.companyType || '—'}</p>
        <p><strong>TVA:</strong> {profile.details?.tvaApplicable || '—'}</p>
        {/* You can add more fields here */}
      </div>
    </div>
  );
};

export default WorkshopProfile;
